import {useTranslation} from 'react-i18next';
import {RefreshCw} from 'lucide-react';
import {Button} from '@chekinapp/ui';
import {useRetryAppLoad} from 'hooks/useRetryAppLoad';
import {TerminalScene} from 'components/TerminalScene';

function OfflineView() {
  const {t} = useTranslation();
  const handleRetry = useRetryAppLoad();

  return (
    <TerminalScene
      title={t('splash_offline_title')}
      subtitle={t('splash_offline_subtitle')}
      announce={t('splash_offline_announce')}
    >
      <Button variant="outline" className="w-full" onClick={handleRetry}>
        <RefreshCw size={16} aria-hidden="true" />
        {t('splash_offline_retry')}
      </Button>
    </TerminalScene>
  );
}

export {OfflineView};
